/* Drapery category estimator.
 * Pleat and stack geometry comes from the public curtain calculator and depends
 * on header style and finished width. Weight remains disabled until an adapter
 * declares its fabric and calculation inputs verified. */
(function (root) {
  const headerFullness = {
    'Double Pleats': 2.2,
    'Triple Pleats': 2.5,
    Goblet: 2.2,
    Grommet: 2.2,
    'Soft Top': 3
  };
  const liningGsm = {
    Unlined: 0,
    'Standard Privacy Liner': 174,
    'Medium Room Darkening Liner': 206,
    'Thermal Heavyweight Blackout Liner': 325,
    'Standard Blackout Liner': 236
  };
  const numeric = value => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : null;
  function calculate({style, widthIn, lengthIn, lining, quantity, weightFacts = {}}) {
    const width = numeric(widthIn), length = numeric(lengthIn);
    const result = {pleats: null, stack: null, weight: null, totalWeight: null, reason: {}};
    if (!style) result.reason.pleats = result.reason.stack = 'Choose a header style.';
    else if (!width) result.reason.pleats = result.reason.stack = 'Enter the width for one panel.';
    else if (style === 'Double Pleats' || style === 'Triple Pleats') {
      const metres = width * 0.0254;
      const triple = style === 'Triple Pleats';
      const factor = metres <= (triple ? 1 : 1.5) ? 2.4 : metres >= 4 ? 2 : 2.2;
      const pleats = Math.ceil((metres * factor) / 0.24);
      const range = triple ? [1.5, 2] : [0.8, 1.2];
      result.pleats = pleats;
      result.stack = [Math.round(pleats * range[0]), Math.round(pleats * range[1])];
    } else result.reason.pleats = result.reason.stack = 'Pleat & Stack estimates are unavailable for this header.';

    if (weightFacts.verified !== true) result.reason.weight = 'Weight estimate unavailable: calculation inputs are not fully verified for this fabric.';
    else if (!style) result.reason.weight = 'Choose a header style.';
    else if (!width) result.reason.weight = 'Enter the width for one panel.';
    else if (!length) result.reason.weight = 'Enter the length for one panel.';
    else if (!lining) result.reason.weight = 'Choose a lining.';
    else {
      const selectedLining = Object.keys(liningGsm).find(name => lining.trim() === name || lining.trim().startsWith(name + ' |'));
      const fabricGsm = numeric(weightFacts.fabricGsm);
      if (!selectedLining || !headerFullness[style] || !fabricGsm) result.reason.weight = 'No verified weight estimate for this option.';
      else {
        const kg = headerFullness[style] * width * length * 0.00064516 * ((fabricGsm + liningGsm[selectedLining]) / 1000);
        result.weight = Math.ceil(kg * 2.204);
        const count = numeric(quantity);
        if (count && Number.isInteger(count)) result.totalWeight = result.weight * count;
      }
    }
    return result;
  }
  const api = Object.freeze({calculate});
  root.czDraperyEstimates = api;
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('cz-drapery-estimates-ready'));
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
